import { ArrowLeftIcon, ArrowRightIcon } from '@radix-ui/react-icons';
import { Badge, Separator } from '@radix-ui/themes';
import { MetricHelper } from 'classes/helpers/metric.helper';
import { MachineContext } from 'contexts/machine.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ITrajektRefBreak } from 'lib_ts/interfaces/pitches';
import { useContext } from 'react';

export const CommonHorizontalBreaksBadge = (props: {
  breaks: ITrajektRefBreak;
}) => {
  const { machine } = useContext(MachineContext);
  const { isMetric } = machine;

  const breaks = -props.breaks.xInches;

  const breaksTowardsFirst = breaks < 0;

  const icon = breaksTowardsFirst ? <ArrowRightIcon /> : <ArrowLeftIcon />;
  const title = breaksTowardsFirst
    ? 'From hitter POV: Breaks toward 1st base'
    : 'From hitter POV: Breaks toward 3rd base';

  const value = isMetric ? MetricHelper.inToCm(breaks) : breaks;
  const units = MetricHelper.getBreaksUnit(isMetric, true);

  return (
    <Badge color={RADIX.COLOR.NEUTRAL} title={title}>
      {value.toFixed(0)}
      <span className="BadgeUnits">{units}</span>
      <Separator orientation="vertical" style={{ height: '11px' }} />
      {icon}
    </Badge>
  );
};
